import { colors, fonts, spacing } from '../theme';
import Icon from './Icon';
import Button from './Button';

const styles = {
  container: {
    textAlign: 'center',
    padding: spacing['3xl'],
    color: colors.midGray,
  },
  icon: {
    marginBottom: spacing.lg,
    color: colors.gray400,
  },
  title: {
    fontFamily: fonts.heading,
    fontSize: '1.5rem',
    fontWeight: 600,
    color: colors.darkGray,
    marginBottom: spacing.md,
  },
  description: {
    fontFamily: fonts.body,
    fontSize: '1rem',
    lineHeight: 1.6,
    color: colors.midGray,
    marginBottom: spacing.xl,
    maxWidth: '500px',
    margin: `0 auto ${spacing.xl} auto`,
  },
  actions: {
    display: 'flex',
    gap: spacing.md,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
};

function EmptyState({ 
  icon = 'document', 
  iconType = 'document',
  title, 
  description, 
  actionLabel = null, 
  onAction = null,
  secondaryActionLabel = null,
  onSecondaryAction = null,
}) {
  return (
    <div style={styles.container}>
      {icon && (
        <div style={styles.icon}>
          <Icon name={icon} type={iconType} size={64} color={colors.gray400} />
        </div>
      )}
      {title && <h3 style={styles.title}>{title}</h3>}
      {description && <p style={styles.description}>{description}</p>}
      {(actionLabel || secondaryActionLabel) && (
        <div style={styles.actions}>
          {actionLabel && onAction && (
            <Button onClick={onAction} variant="primary">
              {actionLabel}
            </Button>
          )}
          {secondaryActionLabel && onSecondaryAction && (
            <Button onClick={onSecondaryAction} variant="outline">
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default EmptyState;

